import { type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { getViewTabTestId } from './utils'
import {
  segmentedControlsCounterVariants,
  segmentedControlsIconVariants,
  segmentedControlsVariants,
} from './variants'

export interface SegmentedControlsProps
  extends
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof segmentedControlsVariants> {
  counter?: number
  label?: React.ReactNode
  icon?: React.ReactNode
}

export function SegmentedControls({
  className,
  counter,
  label,
  icon,
  selected = false,
  ...props
}: SegmentedControlsProps) {
  return (
    <button
      type='button'
      aria-pressed={!!selected}
      {...props}
      className={cn(segmentedControlsVariants({ selected }), className)}
      data-testid={getViewTabTestId(label ?? props['aria-label'])}
    >
      {icon && <span className={segmentedControlsIconVariants({ selected })}>{icon}</span>}
      {label && <span>{label}</span>}
      {counter !== undefined && (
        <span className={segmentedControlsCounterVariants()}>{counter}</span>
      )}
    </button>
  )
}
